module.exports = __webpack_public_path__ + "img/Peter_Hofmann_2025.879681a8.jpg";